var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _rect, _rect2, _path8, _rect3, _rect4, _path9, _rect5, _rect6, _path0, _rect7, _rect8, _path1, _rect9, _rect0, _path10, _rect1, _rect10, _path11, _rect11, _rect12, _path12, _rect13, _rect14, _path13, _rect15, _rect16, _path14, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExteriorBackOverlay = function SvgExteriorBackOverlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 724 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-frontHood-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M100 132.999C89.5 123.999 83 119.499 81 118.499C87 114.898 96.1667 107.999 100 105C134.5 85.9993 171 72.5 209.5 61.5C224 58.0005 234 58.9994 238 58.9989C271 57.9993 299.333 65.9989 313.5 70.9989C320.3 72.5989 336 79.3323 343 82.4989C312.2 87.6989 267.5 103.332 249 110.499C239.4 112.899 207 129.499 192 137.499C190 137.899 169.833 152.666 160 159.999C159.2 160.399 155.667 163.499 154 164.999C152.8 166.599 149.5 167.999 148 168.499C145.2 169.699 140.833 167.332 139 165.999L128.5 157.499L100 132.999Z",
    fill: "#FFA928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-leftMirror-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M130.5 202.999C131.3 204.199 133.166 203.499 134 202.999L160.5 189.498C160.9 189.098 163.666 187.998 165 187.498C166.2 186.698 166.833 184.165 167 182.998C166.6 182.198 164.833 181.665 164 181.498C163.2 180.298 160.166 178.5 159 178C156.5 178 154 178 152 178.999C144.8 182.199 136.666 187.999 133.5 190.499C131.5 192.099 130 195.499 129.5 196.999C128.7 200.199 129.833 202.332 130.5 202.999Z",
    fill: "#FFA928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-frontWindow-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M243 134.501C233 132.901 192.833 146.501 174 153.501C239 107 309 90.0005 342 83C351.6 79.4 372.5 75.6667 381 74.5C328.2 86.5 282.5 108.5 243 134.501Z",
    fill: "#FFA928"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-rightFrontFender-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M343 81.998L350 79.998C328 61.498 304.333 54.6683 296.5 54.0015C275.3 52.0015 251 55.9981 239.5 58.9981C279.5 57.4981 311 68.998 343 81.998Z",
    fill: "#FFA928"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-roof-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M390 72.9991C324.8 85.3991 265.333 119.333 244 134.5C275.5 136.5 313.5 160.5 344 179C349.5 182 412.667 224.833 444.5 247L448.5 248.5C455.3 241.3 537.667 202.667 578 184.5L579 182C555 152.5 503.833 120.5 480.5 107C449 88 422.5 76.4994 411.5 72.9991C399.1 70.1991 392 71.8325 390 72.9991Z",
    fill: "#FFA928"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-frontBumper-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M51.4999 150.5L59.4999 144.5C59.5 145 61.4998 155.167 61.9998 160.5C61.9998 161.3 62.6664 174.167 62.9998 180.5L64.9998 185L67.9998 191C64.7998 193.4 62.3331 199.333 61.4998 202C59.0998 208 63.1664 226.833 65.4998 235.5L66.4998 239.5C58.4998 235.5 53.4998 226.5 51.9998 222.5L51.4999 216.5C45.0999 200.9 41.4999 186 40.4999 180.5C38.0999 171.3 38.8332 165.667 39.4999 164C41.0999 159.2 48.1665 153 51.4999 150.5Z",
    fill: "#FFA928"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-rightBackFender-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.5 376C677.518 375.981 677.535 375.961 677.553 375.942C678.767 374.51 681.015 364.777 682 361C682.913 357.5 682.167 331.667 681.5 319L683 317.5C687.4 313.9 690.167 307.333 691 304.5L692 331.5C695.588 355.423 683.081 369.907 677.553 375.942C677.535 375.963 677.518 375.982 677.5 376Z",
    fill: "#FFA928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.5 278C690.1 284.8 682.167 295.5 678.5 299.5C678.5 299.1 677.667 296.833 677 296C671 291 667 288 662 283.5C658.5 280.5 654 274.5 646 263L646.5 261.5L651.5 248L660 252C660 252 661 252.5 668 256.5C675 260.5 682.5 267.5 682.5 267.5C686 271 686.9 271.2 688.5 278Z",
    fill: "#FFA928"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftFrontDoor"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-leftFrontDoor-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M145.5 197.499C142.3 198.299 142.833 252.833 143.5 279.999L249.5 355V348L253.5 338.5C254 337.5 254.5 334 254.5 332C254.1 332 253 329.333 252.5 328C250.9 323.6 252 307.5 253 299C253 293 256.5 279.5 258.5 273.5C264 262 266 261.167 269.5 257C270.7 256.2 274 249.333 275.5 246C274.3 244.4 276 242.667 277 242C277.8 238.4 295 198.167 303.5 178.5C302.3 177.3 304 176 305 175.5L282.5 163C259.7 151.8 242 148.666 236 148.499C225.6 146.499 203 152.999 193 156.499C173 163.499 162 173.5 159 178C160.2 178 163 180.333 164 181.499C165.2 181.499 166.5 182.499 167 182.999C167 184.199 166 186.499 165.5 187.499C165.1 187.499 164 187.833 163.5 187.999L145.5 197.499Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftFrontDoor-point",
    className: "svg-exterior-point"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 232,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 200,
    y: 254.091,
    id: "exterior-back-leftFrontDoor-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 232,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftFrontFender"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-leftFrontFender-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M146.5 169L151 179.5C149.8 179.9 141.833 184.5 138 187C130.8 191.4 129 196.167 129 198C128.6 200.8 129.833 202.5 130.5 203C130.9 203.8 132.333 203.667 133 203.5L145 197.5C141.8 199.9 142.667 253.5 143.5 280L133 273.5C131.5 259 122.5 237.667 117.5 228C111.9 214.8 98.5 201.5 92.5 196.5C81.7 187.3 72 189 68.5 191L65 185L63 180.5L62 166C62.8 164.4 60.6667 150.667 59.5 144L60 142.5L60 138C59.6 135.2 61.8333 132.833 63 132C63 131.2 75 122.667 81 118.5C83 118.5 102.5 135.5 112 144C120.8 152 135 163 141 167.5C142.5 168 144 169 146.5 169Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftFrontFender-point",
    className: "svg-exterior-point"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 153,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 97,
    y: 175.091,
    id: "exterior-back-leftFrontFender-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 153,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftFrontWheel"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-leftFrontWheel-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M78.0003 201L91.0003 195.5C110 210.5 119.5 230.667 124 242C131 260 132.167 270.833 133 277.5L138 288.5L145.5 294C145.5 294.4 145.167 294.5 145 294.5L122.5 304.5C120.1 304.9 117.167 304.667 116 304.5C107.6 303.7 99.1669 296.167 96.0002 292.5C87.2002 283.7 79.0003 268.167 76.0003 261.5C69.2003 246.3 67.8337 231.167 68.0003 225.5C68.0003 215.9 70.667 208.833 72.0003 206.5C73.6003 203.7 76.667 201.667 78.0003 201Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftFrontWheel-point",
    className: "svg-exterior-point"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.0002,
    y: 232,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 97.25,
    y: 254.091,
    id: "exterior-back-leftFrontWheel-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.0002,
    y: 232,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftBackDoor"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-leftBackDoor-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M303.5 178.5C302.3 177.7 304 176 305 175.5C320.2 182.7 358.667 211.167 376 224.5C374.8 226.5 376.5 229 377.5 230L388.5 299C386.5 301.4 388 303 389 303.5V314C389 317.2 387.667 320.667 387 322C385.4 324 383.667 330.167 383 333C383.8 335.8 381 347.167 379.5 352.5C378.375 356.5 371.167 374.333 367 382.5C356.6 381.7 348 383.5 343.5 386C334.489 391.006 328.5 402.667 326.5 408.5C325.5 406 275 372.333 249.5 355V348L253 340C254.5 337 254.5 334 254.5 332C253 330 252 326.167 252 324.5C251.5 294.5 257 277.5 259 272.5C261 267.3 264.833 262.667 266.5 260.5C268.9 258.5 271.5 254 272.5 252L275.5 246C274.3 244.4 276 242.667 277 242L290 210.5L303.5 178.5Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftBackDoor-point",
    className: "svg-exterior-point"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 303,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 316.9,
    y: 325.091,
    id: "exterior-back-leftBackDoor-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 303,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftRearFender"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-leftRearFender-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M369 396L367 382.5C372.5 372 381 350.5 382 342.5L383.5 332C383.667 330.333 386 324.5 388.5 318C389.807 314.603 389 303.9 389 303.5C394.833 305.833 407.6 310.4 410 310C412.833 310.5 419 311.3 421 310.5C422.167 310 424.7 308.7 425.5 307.5L510 322.5L526 344.5L543 366.5C543.5 367.667 544.6 371 545 373C538.667 375.333 521.6 380 508 380C501 380.333 485 380.2 477 377C475 375.833 470.6 374.2 469 377C468.167 379.333 469.7 385.7 482.5 392.5C488.667 395 502.7 400.1 509.5 400.5C513.667 400.833 523.5 401 529.5 399L545 395C546.333 408.833 549.4 437.1 551 439.5C551.635 440.452 551.871 440.859 551.883 440.951C553.635 442.778 556.67 445.667 558 446C553.5 447.667 544 450 534.5 451.5C521.5 453 495 455 473 444L471 443L453.5 451.5L435.5 460.5C426.667 442 401 403.6 369 396Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftRearFender-point",
    className: "svg-exterior-point"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 365,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 424.9,
    y: 387.091,
    id: "exterior-back-leftRearFender-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 365,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftBackLight"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-leftBackLight-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M478.5 379C477.3 378.2 473.667 378 472 378C470.4 378 470.667 380 471 381C472.2 384.2 477.167 387.333 479.5 388.5C488.3 393.3 501.5 396.167 507 397C520 398 537.5 394 547 390.5L571.5 379C572.3 378.6 572.167 377.833 572 377.5L568.5 371.5C567.3 369.9 567 369.833 567 370C566.6 370 564.167 370.666 563 371C555 373.8 544 376.5 539.5 377.5C533.5 379 520 381.166 513 382C506.6 382.8 495.667 382 491 381.5C490 381.5 480 380 478.5 379Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftBackLight-point",
    className: "svg-exterior-point"
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 517,
    y: 369,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 533.9,
    y: 391.091,
    id: "exterior-back-leftBackLight-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 517,
    y: 369,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-backDoor"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-backDoor-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M479.5 232C463.16 240.424 453.5 245 449 248C448.2 248 449.666 249.999 450.5 250.999L469.5 271.499C471.5 273.499 495 301.5 505.5 315.999L531 350.999L542.5 365.999C543.3 367.199 544.166 369.166 544.5 369.999L545 372.999L563 367.999C567.4 366.399 569.166 367.332 569.5 367.999C570.3 368.399 573.166 372.499 574.5 374.499C575.3 375.299 575.5 376.832 575.5 377.499C575.1 379.499 572.333 381.332 571 381.999L546 394.499L549 425.999C549.4 431.199 551.833 436.499 553 438.499C555.8 443.699 563.166 442.666 566.5 441.499L586.5 433.499C610.5 423.099 637.166 406.499 647.5 399.499C651.5 397.099 666.166 384.832 673 378.999C677.8 374.599 680.333 364 681.5 357C681.9 354.6 681.5 330.999 681 318.999L668.5 326.999C666.9 326.999 666.833 325.999 667 325.499L668.5 310.999L678.5 299.499L677.5 296.999L677 295.999C676.5 295.499 673 292.666 671.5 291.499C663 286 660 282 657 278.499C646 262.5 615.5 223.5 594 201.499L594 200L579 185.5C577.5 185 576 185.501 573 187C564.5 191.001 511.5 215.5 479.5 232Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-backDoor-point",
    className: "svg-exterior-point"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 571,
    y: 273,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 587.9,
    y: 295.091,
    id: "exterior-back-backDoor-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 571,
    y: 273,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-backBumper"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-backBumper-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M471.5 443.5L471 443L452.5 452L435.5 460.5C443.5 474 448 496 449.5 507.5L454.5 511.5C465.3 513.9 482 512.913 492.5 512C504 511 514 508.167 520.5 506.5C527.3 504.5 546.333 496 555 492C573 483.692 601.5 468.333 614.5 460.5C625 454.5 642.667 442 652.5 435C661.7 428.6 672.5 419 677 414C679.911 410.766 684.833 400.833 686.5 396.5L687 396L690 385.5L690.5 381.5L695.5 357.5C698.7 343.9 694.833 331.5 692.5 327L693 338C694.2 356 682.5 371.833 676.5 377.5C644.1 409.5 583.667 436.833 557.5 446.5C513.1 459.3 481.667 449.833 471.5 443.5Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-backBumper-point",
    className: "svg-exterior-point"
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 425,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 613.75,
    y: 447.091,
    id: "exterior-back-backBumper-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 425,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-rightBackLight"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-rightBackLight-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M670.5 314.5L669.5 324L682.5 314.5C686.9 310.1 689.333 304.333 690 302C691.2 299.6 690.833 295.667 690.5 294C691.7 292.4 692 288.667 692 287C692 284.2 690.667 281.5 690 280.5C690.4 282.1 689.833 284.833 689.5 286C689.5 287.6 685.833 294.333 684 297.5C683.6 298.7 676.167 306.667 672.5 310.5C671.3 311.7 670.667 313.667 670.5 314.5Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-rightBackLight-point",
    className: "svg-exterior-point"
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 283,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 682.75,
    y: 305.091,
    id: "exterior-back-rightBackLight-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 283,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftBackWheel"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-back-leftBackWheel-overlay",
    className: "svg-exterior-overlay",
    opacity: 0.3,
    d: "M418.5 524.5L449 506.5C445.4 470.5 423.833 438.5 413.5 427C397.5 407.8 382.833 400.333 377.5 399L355.5 410C344.5 417.5 344.5 430.5 344 436C344 452.5 348.517 464.545 351 471C357 486.6 367.833 500.667 372.5 505.5C384.716 518.153 394.833 522.667 400.5 524.5C408.729 527.162 415.167 525.833 418.5 524.5Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-back-leftBackWheel-point",
    className: "svg-exterior-point"
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 446,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 387,
    y: 468.091,
    id: "exterior-back-leftBackWheel-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 446,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))));
};
export default SvgExteriorBackOverlay;